/* global PUB_SUB_EVENTS, subscribe */

(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
    const sectionId = payload?.data?.sectionId;
    const variant = payload?.data?.variant;
    if (!sectionId || !variant) return;

    const skuEl = document.getElementById(`ProductSku-${sectionId}`);
    if (skuEl) skuEl.textContent = variant.sku || '';

    const weightEl = document.getElementById(`ProductWeight-${sectionId}`);
    if (weightEl) {
      const grams = Number(variant.weight || 0);

      if (!grams) {
        weightEl.textContent = '';
      } else if (grams >= 1000) {
        weightEl.textContent = (grams / 1000).toFixed(1).replace('.', ',') + ' kg';
      } else {
        weightEl.textContent = grams + ' g';
      }
    }
  });
})();
